module.exports = __webpack_public_path__ + "static/img/auth_logo.cbf2ca4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/auth_logo.png
// module id = ycX4
// module chunks = 1